import {useState} from 'react';
import postAddInstanceField from '../functions/API/postAddInstanceField.js'
import { toast } from '../lib/toast.js';

const FIELD_TYPE_OPTIONS = [
    { value: 'TEXT', label: 'Text Input' },
    { value: 'TEXTAREA', label: 'Text Area' },
    { value: 'DATE', label: 'Date' },
    { value: 'NUMBER', label: 'Number' },
    { value: 'BOOLEAN', label: 'Boolean' },
    { value: 'FILE', label: 'File' },
    { value: 'DROPDOWN', label: 'Dropdown' },
    { value: 'MULTI_SELECT', label: 'Multi-Select' },
];

export default function AddInstanceFieldForm({stepId, setVisible, onFieldAdded}) {
    const [formData, setFormData] = useState({
        name_snapshot: "",
        field_type_snapshot: "TEXT",
        is_required_snapshot: false,
    });

    async function handleSubmit() {
        if (!formData.name_snapshot) {
            toast.error('Field name is required.');
            return;
        }

        const body = {
            task_instance_step_id: stepId,
            name_snapshot: formData.name_snapshot,
            field_type_snapshot: formData.field_type_snapshot,
            is_required_snapshot: formData.is_required_snapshot,
        };

        const response = await postAddInstanceField(body);
        if (response.response.ok) {
            toast.success('Field added successfully.');
            setVisible(false);
            if (onFieldAdded) onFieldAdded();
        } else {
            toast.error('Failed to add field.');
        }
    }

    function handleChange(event) {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setFormData({...formData, [name]: value});
    }

    return (
        <form>
            <div className="space-y-8">
                <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900 dark:text-white">
                        Add Field
                    </h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600 dark:text-gray-400">Add an ad-hoc field to this step</p>
                </div>

                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 md:col-span-1">
                    <div className="sm:col-span-3">
                        <label htmlFor="name_snapshot" className="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
                            Name
                        </label>
                        <div className="mt-2">
                            <input
                                required
                                type="text"
                                onChange={handleChange}
                                value={formData.name_snapshot}
                                name="name_snapshot"
                                id="name_snapshot"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-white dark:bg-zinc-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-zinc-600 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <label htmlFor="field_type_snapshot" className="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
                            Field Type
                        </label>
                        <div className="mt-2">
                            <select
                                onChange={handleChange}
                                name="field_type_snapshot"
                                id="field_type_snapshot"
                                value={formData.field_type_snapshot}
                                className="pl-2 block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-white dark:bg-zinc-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-zinc-600 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                            >
                                {FIELD_TYPE_OPTIONS.map(ft => (
                                    <option key={ft.value} value={ft.value}>{ft.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                onChange={handleChange}
                                name="is_required_snapshot"
                                id="is_required_snapshot"
                                checked={formData.is_required_snapshot}
                                className="h-4 w-4 rounded border-gray-300 dark:border-zinc-600 text-blue-700 focus:ring-blue-700"
                            />
                            <label htmlFor="is_required_snapshot" className="ml-3 block text-sm font-medium text-gray-900 dark:text-white">
                                Required
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-6 flex items-center justify-start gap-x-6">
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                >
                    Add Field
                </button>
                <button type="button" onClick={() => setVisible(false)} className="text-sm font-semibold leading-6 text-gray-900 dark:text-white">
                    Cancel
                </button>
            </div>
        </form>
    );
}
